import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PepCellNotesData.html?raw';

import { ColorHelpers, EntityHelpers, HtmlHelpers, ToasterHelpers } from "../../../more/Helpers";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { PEP } from "../PepTypes";



class PEPcellNotesData extends compose(_WidgetBaseSP) {
	templateString: any = template;

    private txtContent: HTMLElement;
    private txtLabel: HTMLElement;
    private _data: PEP.CellNotesData;
    private _isClickable: boolean = false;

    setData(data: PEP.CellNotesData, enableClick?: boolean): void {

        if (!data) return;

        this._data = data;
        if (typeof (enableClick) != "boolean") {
            enableClick = !!data.entityID && !!data.Classname;
        }
        this._isClickable = enableClick == true;

        this.UiModder.domAttr.set(this.txtLabel, "innerHTML", data.title);
        this.UiModder.domAttr.set(this.txtContent, "innerHTML", data.infotext);
        this.hideNode(this.txtContent, !data.infotext);



        this.UiModder.domClass.toggle(this.domNode, "warning", data.warningLevel == 1);
        this.UiModder.domClass.toggle(this.domNode, "critical", data.warningLevel >= 2);

        this.UiModder.domClass.toggle(this.domNode, "hoverAuto", this._isClickable);

        if (data.color) {
            ColorHelpers.colorNode(this.domNode, data.color);
        }
        if (data.icon) HtmlHelpers.createFontawesomeIcon(data.icon + " showInGrid", false, this.domNode, "first");
    }

    private _onClick_Domnode(evt: MouseEvent) {

        //evt.stopPropagation();
        if (this._isClickable != true) return;
        else {
            evt.stopPropagation();
            evt.preventDefault();
        }

        if (this._data.Classname && this._data.entityID) {
            let entityview = new GenericEntityView();
            entityview.setup({
                entityId: this._data.entityID,
                entityClass: this._data.Classname,
                label: this._data.title,
                contextName: "PEPcellInfo"
            });

            entityview.on("change", lang.hitch(this, this._onChangeEntityview));
        }
    }

    private _onChangeEntityview() {
        this.emit("update");
    }
    

    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PEPcellNotesData);